import { useReduxState } from 'hooks';
import { CopyButton } from 'components/common';
import { FormGroup } from 'components/common/form';

interface Props {
  productIdentifier: string;
}

const ProductIdentifier = ({ productIdentifier }: Props) => {
  const { messages, serverConfig, theme } = useReduxState();

  if (!serverConfig.showProductIdentifier) return null;

  return (
    <FormGroup label={messages.commonIdentifier || 'Identifier'}>
      <div className="inner">
        <div className="identifier">{productIdentifier}</div>

        <CopyButton
          category="light"
          size="small"
          successText={messages.commonCopied}
          tooltip={messages.commonCopy}
          value={productIdentifier}
        />

        <style jsx>{`
          .inner {
            align-items: center;
            display: flex;
            gap: 10px;
            width: 340px;
          }
          .identifier {
            background-color: ${theme.lightGreyLighter};
            border-radius: ${theme.inputBorderRadius};
            color: ${theme.textColorLight};
            font-size: 1.4rem;
            font-weight: 400;
            padding: 5px 10px;
          }
        `}</style>
      </div>
    </FormGroup>
  );
};

export default ProductIdentifier;
